import styled from '@emotion/styled';
import React from 'react';
import { USPProps } from '../Summary.definitions';
import Checkmark from '~/icons/checkmark.svg';
import { RawHtml } from '../../RawHtml';
import { StyledRichText } from '~/shared/components/RawHtml/styled';
import { StyledText } from '../../Text/styled';

const USPsWrapper = styled.div(({ theme }) => ({
    overflow: 'hidden',
    position: 'relative',
    padding: `${theme.space[5]} ${theme.space[3]}`,
    background: theme.colors.grey10,
    borderTop: `1px solid ${theme.colors.headerSearchInputBorderColor}`,
    boxShadow: 'inset 0px 30px 30px -25px rgba(0,0,0,0.2)',
}));

const Usp = styled.ul(({ theme }) => ({
    li: {
        '&:last-child': {
            paddingBottom: 0,
        },
        paddingBottom: theme.space[1],
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        gap: theme.space[2],
        svg: {
            marginTop: 2,
            flexShrink: 0,
        },
    },
    [`${StyledRichText}`]: {
        'p,ul': {
            marginBottom: theme.space[1],
        },
        strong: {
            fontWeight: theme.mixins.useFontWeight('Bold'),
        },
    },
    [`${StyledText}`]: {
        ...theme.mixins.useTextStyle('bodySmall'),
    },
}));

const Shadow = styled.div<{ shadowDirection?: 'down' | 'up' }>(({ shadowDirection = 'down' }) => ({
    boxShadow: '0 2px 20px rgba(0,0,0,0.2)',
    height: 10,
    position: 'absolute',
    left: 0,
    right: 0,
    top: shadowDirection === 'down' ? -10 : 'auto',
    bottom: shadowDirection === 'up' ? -10 : 'auto',
}));
export const USPs = ({ usps, shadowBottom, shadowTop, tags }: USPProps) => {
    if (!usps) return null;
    return (
        <USPsWrapper>
            {shadowTop && <Shadow shadowDirection="down" />}
            <Usp>
                {usps.map((usp, index) => {
                    if (!usp.tags.length || tags?.some((tag) => usp.tags.includes(tag)))
                        return (
                            <li key={index}>
                                <Checkmark />

                                <RawHtml html={usp.text} />
                            </li>
                        );
                })}
            </Usp>
            {shadowBottom && <Shadow shadowDirection="up" />}
        </USPsWrapper>
    );
};
